import { useState, useCallback } from 'react';
import useSummaryAvailable from '@Containers/Summary/hooks/useSummaryAvailable';
import { trackHowItWorksClick } from '@Containers/Summary/analytics';

// FR-1.14: the old auto-fetch effect (fetchSummary on mount whenever available) is removed
// outright — generation only ever happens from an explicit button click (FR-1.1/1.2/1.11/1.12).
// FR-1.6: no reset-on-unmount either — entries persist across navigation within a session.
function useSummaryContainer({ activeBreadcrumb }) {
  const trackingContext = activeBreadcrumb?.context;
  const [howItWorksPanelVisible, setHowItWorksPanelVisible] = useState(false);
  const toggleHowItWorksPanel = useCallback(() => {
    setHowItWorksPanelVisible((prevState) => {
      const nextState = !prevState;
      if (nextState) {
        trackHowItWorksClick(trackingContext);
      }
      return nextState;
    });
  }, [trackingContext]);

  const { isSummaryAvailable, chainKey, rootBreadcrumb } = useSummaryAvailable({ activeBreadcrumb });

  return {
    isSummaryAvailable,
    chainKey,
    rootBreadcrumb,
    howItWorksPanelVisible,
    toggleHowItWorksPanel,
  };
}

export default useSummaryContainer;
